import { useCallback } from 'react';

import { selectAppState, selectMaxImageSize } from '@vlabs/shared/selectors/appSelectors';
import { connect } from 'react-redux';

import { viewerCan } from '@vlabs/pages/auth/selectors';

import { SearchProvider } from './ui/search-provider/SearchProvider';
import { SearchPageView } from './ui/SearchPageView';

interface SearchContainerProps {
  appState: string;
  can: (permissions: string[], params?: Record<string, string>) => boolean;
  maxImageSize?: number | null;
  includedAttributes?: string[];
}

function SearchContainer({
  appState,
  can,
  maxImageSize = undefined,
  includedAttributes = [],
}: SearchContainerProps): JSX.Element {
  const canSearch = useCallback(() => appState === 'loaded', [appState]);

  return (
    <SearchProvider canSearch={canSearch}>
      <SearchPageView
        can={can}
        includedAttributes={includedAttributes}
        maxImageSize={maxImageSize}
      />
    </SearchProvider>
  );
}

const connectedPage = connect(
  (state) => ({
    appState: selectAppState(state),
    can: viewerCan(state),
    maxImageSize: selectMaxImageSize(state),
  }),
)(SearchContainer);

export {
  connectedPage as SearchPage,
};
